import React, { useEffect } from "react";
import { bindActionCreators } from "redux";


import { ToasterPush, useToaster } from "@twilio-paste/core";
import { Toaster } from "@twilio-paste/toast";

import { actionCreators, AppState } from "../store";
import useDispatch from "../hooks/useDispatch";
import useSelector from "../hooks/useSelector";

const Notifications: React.FC = () => {
  const toaster = useToaster();
  const notifications = useSelector((state: AppState) => state.notifications);
  const dispatch = useDispatch();
  const { removeNotifications } = bindActionCreators(actionCreators, dispatch);

  useEffect(() => {
    if (!notifications.length) {
      return;
    }
    notifications.forEach((notification) =>
        toaster.push({
          message: notification.message, // required
          variant: notification.variant,  // 'success' | 'error' | etc
          dismissAfter: notification.dismissAfter,
        } as ToasterPush));
      //toaster.push(notification as ToasterPush)
    //);
    removeNotifications(notifications.length);
  }, [notifications]);

  return <Toaster {...toaster} />;
};

export default Notifications;
